function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
/**
 * Default column data formatter. Just interpolates the value as a string and returns.
 * Extend this class and register with TableUtils to make use of it.
 */

export class TableColumnFormatter {
  /**
   * Validates format object
   * @param dh JSAPI instance
   * @param format Format object
   * @returns true for valid object
   */
  static isValid(dh, format) {
    return true;
  }

  /**
   * Check if the given formats match
   * @param formatA format object to check
   * @param formatB format object to check
   * @returns True if the formats match
   */
  static isSameFormat(formatA, formatB) {
    throw new Error('isSameFormat not implemented');
  }

  /**
   * Create and return a Format object
   * @param label The label of the format object
   * @param formatString Format string to use for the format
   * @param type The type of column to use for this format
   * @returns A format object
   */
  static makeFormat(label, formatString, type) {
    return {
      label,
      formatString,
      type
    };
  }

  /**
   * @param value The value to format
   * @param format Optional format object with value transformation options
   * @returns String the formatted text string of the value passed in.
   */
  format(value, format) {
    return '';
  }
}
_defineProperty(TableColumnFormatter, "TYPE_GLOBAL", 'type-global');
_defineProperty(TableColumnFormatter, "TYPE_CONTEXT_PRESET", 'type-context-preset');
_defineProperty(TableColumnFormatter, "TYPE_CONTEXT_CUSTOM", 'type-context-custom');
export default TableColumnFormatter;
//# sourceMappingURL=TableColumnFormatter.js.map